export default function OmiRoomWaiting({ room, user, onLeave }) {
  if (!room) return null;

  const players = room.players || [];
  const myUid = user?.uid;
  const allJoined = players.length === 4;

  return (
    <div className="w-full rounded-[30px] bg-[#161d28] p-5 shadow-[0_24px_70px_rgba(0,0,0,0.28)]">
      <div className="flex flex-wrap items-center justify-between gap-3">
        <div>
          <div className="text-xs uppercase tracking-[0.24em] text-emerald-300">
            Omi Table
          </div>
          <div className="mt-2 text-3xl font-black text-white">{room.roomId}</div>
        </div>
        <div className="rounded-full bg-emerald-500/15 px-4 py-2 text-sm font-bold text-emerald-300">
          Entry Fee: {Number(room.betAmount || 0).toFixed(2)} USDT
        </div>
      </div>

      <div className="mt-6 grid gap-4 sm:grid-cols-2 xl:grid-cols-4">
        {Array.from({ length: 4 }, (_, index) => {
          const player = players[index];
          return (
            <div
              key={player?.userId || `seat-${index + 1}`}
              className="rounded-[22px] border border-white/10 bg-[#1d2531] p-4 text-center"
            >
              {player ? (
                <>
                  <img
                    src={player.avatar || "/default-avatar.png"}
                    alt={player.username}
                    className="mx-auto h-20 w-20 rounded-full border-4 border-emerald-400/30 object-cover"
                  />
                  <div
                    className={`mt-3 text-base font-black ${
                      player.userId === myUid ? "text-emerald-300" : "text-white"
                    }`}
                  >
                    {player.username}
                    {player.userId === myUid ? " (You)" : ""}
                  </div>
                </>
              ) : (
                <>
                  <div className="mx-auto flex h-20 w-20 items-center justify-center rounded-full border-4 border-dashed border-slate-600 text-3xl font-black text-slate-500">
                    ?
                  </div>
                  <div className="mt-3 text-base font-bold text-slate-400">Waiting...</div>
                </>
              )}
              <div className="mt-2 text-xs uppercase tracking-[0.18em] text-slate-500">
                Seat {index + 1}
              </div>
            </div>
          );
        })}
      </div>

      <div className="mt-6 flex flex-col items-center gap-3">
        {!allJoined ? (
          <div className="text-center text-sm font-semibold text-yellow-300">
            {players.length} / 4 players joined. Waiting for the full table.
          </div>
        ) : (
          <div className="text-center text-sm font-semibold text-emerald-300">
            Table is full. Launching the match...
          </div>
        )}

        <button
          type="button"
          onClick={onLeave}
          className="rounded-[18px] bg-[#d64045] px-5 py-3 text-sm font-bold text-white"
        >
          Leave Table
        </button>
      </div>
    </div>
  );
}
